import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { useUserContext } from '../../hooks/userContext';
import { Pages, isAdminUser } from '../../utils';
import { CircularProgress, Box } from '@mui/material';
import { useEffectiveRole } from '../../hooks/useEffectiveRole';

/**
 * DesignerOnlyRoute ensures only designers can access certain routes.
 * Redirects non-designers to appropriate pages.
 * Admins can access when not impersonating.
 */
export const DesignerOnlyRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const { user, loading } = useUserContext();
  const { isDesigner, isAdmin } = useEffectiveRole();


  // Show loading while checking user status
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress sx={{ color: '#00A06D' }} />
      </Box>
    );
  }

  // If no user, redirect to login
  if (!user) {
    return <Navigate to={Pages.LOGIN} replace />;
  }

  // Admins can access (unless impersonating non-designer)
  if (isAdmin && !isDesigner) {
    return <>{children}</>;
  }

  // Check if user is a designer
  if (!isDesigner) {
    return <Navigate to={Pages.DASHBOARD} replace />;
  }

  return <>{children}</>;
};